import { render, staticRenderFns } from "./printersTable.vue?vue&type=template&id=7c9165ed"
import script from "./printersTable.vue?vue&type=script&lang=js"
export * from "./printersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports